import { Dropdown } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Menu } from 'components/atoms/dropdown';
import { IconMoreActions } from 'components/atoms/icons/more-actions';
import { useDocuments } from 'components/organisms/document/document-store';
import { PermissionRuleName } from 'constant';
import { usePermissionForRule } from 'hooks/permissions/use-permission';
import { INSERT_DOC_TASK_SECTION_COMMAND } from 'vendor/ckeditor/plugins/document-tasks-section';
import { InsertPrivateSection } from '../private-section';
import { Btn, StyledMenu, ToolBtn, ToolBtnWrapper } from '../styled-components';
import { TaskSectionToolHandler } from '../task-section/task-section-tool-handler';
import { BlockToolsGroup } from '../topbar/types';
import { checkActiveState, checkDefaultEnabled } from '../topbar/utils';

export const InsertBlockEls: FC = () => {
  const [state] = useDocuments();
  const { isAllowedForCurrentUser } = usePermissionForRule();
  const hasCreateTask = isAllowedForCurrentUser(
    PermissionRuleName.TaskCreateAction,
  );
  const hasAccessToAddPrivateSection = isAllowedForCurrentUser(
    PermissionRuleName.SpaceDocumentInsertPrivateSectionAction,
  );

  const InsertSectionsMenu = () => (
    <StyledMenu>
      <Menu.Header>
        <FormattedMessage id="toolbar.sections" />
      </Menu.Header>
      {hasCreateTask ? (
        <Menu.Item>
          <ToolBtn
            commandName={INSERT_DOC_TASK_SECTION_COMMAND}
            editor={state.editor}
            label="toolbar.add_task_section"
            haveItsOwnHandler
            hideTooltip
            command={state.editor?.commands.get(
              INSERT_DOC_TASK_SECTION_COMMAND,
            )}
            haveActiveState={checkActiveState(INSERT_DOC_TASK_SECTION_COMMAND)}
            enabled={checkDefaultEnabled(INSERT_DOC_TASK_SECTION_COMMAND)}
          >
            <TaskSectionToolHandler editor={state.editor} />
          </ToolBtn>
        </Menu.Item>
      ) : null}
      {hasAccessToAddPrivateSection ? (
        <Menu.Item>
          <ToolBtn
            commandName={BlockToolsGroup.InsertPrivateSectionKey}
            editor={state.editor}
            label="toolbar.insert_private_section"
            hideTooltip
            haveItsOwnHandler
            command={state.editor?.commands.get(
              BlockToolsGroup.InsertPrivateSectionKey,
            )}
            haveActiveState={checkActiveState(
              BlockToolsGroup.InsertPrivateSectionKey,
            )}
            enabled={checkDefaultEnabled(
              BlockToolsGroup.InsertPrivateSectionKey,
            )}
          >
            <InsertPrivateSection />
          </ToolBtn>
        </Menu.Item>
      ) : null}
    </StyledMenu>
  );

  return hasCreateTask || hasAccessToAddPrivateSection ? (
    <Dropdown
      overlay={InsertSectionsMenu}
      trigger={['hover']}
      placement="bottomRight"
    >
      <div>
        <ToolBtnWrapper>
          <Btn type="text" icon={<IconMoreActions />} hideHoverEffect />
        </ToolBtnWrapper>
      </div>
    </Dropdown>
  ) : null;
};
